<template>
  <section
    v-if="text || (viewer?.is_owner && ownerViewMode)"
    id="about"
    class="max-w-[1400px] border mx-auto px-6 py-12 md:px-8 md:py-16 border-b border-charcoal-blue"
    aria-labelledby="about-heading-t2"
  >
    <h2 id="about-heading-t2" class="heading-utilitarian text-5xl font-extrabold mb-8 text-charcoal-blue">{{ $t('public.about') }}</h2>
    <p v-if="text" class="text-charcoal-blue/80 whitespace-pre-line font-body">{{ text }}</p>
    <div
      v-else-if="viewer?.is_owner && ownerViewMode"
      class="py-4 px-4 rounded border border-dashed border-charcoal-blue/40 bg-charcoal-blue/5"
    >
      <p class="text-sm font-mono text-charcoal-blue/70">{{ $t('public.noDescriptionSetOwnerMessage') }}</p>
    </div>
  </section>
</template>

<script setup>
defineProps({
  text: { type: String, default: '' },
  viewer: { type: Object, default: () => ({ is_owner: false }) },
  ownerViewMode: { type: Boolean, default: true },
})
</script>
